import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SEOHead from "./SEOHead";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Construction, ArrowLeft, Mail } from "lucide-react";

const UnderConstruction = ({ 
  title, 
  description = "We're working hard to bring you this feature. Check back soon for updates!",
  expectedLaunch = "Coming Soon",
  showContactOption = true 
}) => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title={title}
        description={`${title} - ${description}`}
        url={`/${title.toLowerCase().replace(/\s+/g, '-')}`}
      />
      
      <Header />
      
      <main className="pt-24">
        <section className="py-24 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto text-center">
              <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-amber-500/20 flex items-center justify-center">
                <Construction className="h-12 w-12 text-amber-400" />
              </div>
              
              <h1 className="text-5xl md:text-6xl font-bold mb-8">
                {title}
              </h1>
              <p className="text-xl text-gray-300 mb-4">
                Page Under Construction
              </p>
              <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
                {description}
              </p>
              
              <div className="inline-flex items-center px-6 py-3 bg-amber-500/20 rounded-full border border-amber-400/30 mb-12">
                <span className="text-amber-400 font-semibold">
                  🚧 {expectedLaunch}
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-2xl mx-auto">
              <Card className="shadow-xl">
                <CardContent className="p-12 text-center">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">
                    What can you do in the meantime?
                  </h2>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div className="p-6 bg-white rounded-lg border">
                      <h3 className="font-semibold text-gray-900 mb-2">Explore CNESS</h3>
                      <p className="text-gray-600 text-sm mb-4">Learn about our certification process and framework</p>
                      <a href="/about">
                        <Button variant="outline" size="sm" className="w-full">
                          Learn More
                        </Button>
                      </a>
                    </div>
                    
                    <div className="p-6 bg-white rounded-lg border">
                      <h3 className="font-semibold text-gray-900 mb-2">Get Started</h3>
                      <p className="text-gray-600 text-sm mb-4">Begin your certification journey today</p>
                      <a href="/signup">
                        <Button size="sm" className="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white">
                          Sign Up
                        </Button>
                      </a>
                    </div>
                  </div>

                  {showContactOption && (
                    <div className="border-t pt-6">
                      <p className="text-gray-600 mb-4">
                        Have questions about this feature?
                      </p>
                      <a href="/support">
                        <Button variant="outline" className="mr-4">
                          <Mail className="mr-2 h-4 w-4" />
                          Contact Support
                        </Button>
                      </a>
                      <a href="/">
                        <Button variant="ghost">
                          <ArrowLeft className="mr-2 h-4 w-4" />
                          Back to Home
                        </Button>
                      </a>
                    </div>
                  )}
                </CardContent>
              </Card>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default UnderConstruction;